import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { c as classNames, d as EGDSContextProvider, u as useEGDSContext } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-action-list-item.css';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';

const getClassNameList$2 = classNames.bind(styles);
const EGDSActionList = (props) => {
    const { border, className, children, cornerRadius, ...attr } = props;
    const baseCssClass = 'uitk-action-list';
    const cssClassNames = getClassNameList$2(baseCssClass, className, {
        [`${baseCssClass}-has-border`]: border,
        [`${baseCssClass}-has-corners`]: cornerRadius,
    });
    return (jsx("ul", { className: cssClassNames, ...attr, children: children }));
};
EGDSActionList.displayName = 'EGDSActionList';

const EGDSActionListItemSpacingMap = [
    ['standard', 'standard'],
    ['relaxed', 'relaxed'],
];
const EGDSActionListItemSpacings = new Map(EGDSActionListItemSpacingMap);

const getClassNameList$1 = classNames.bind(styles);
const ActionListItem = (props) => {
    const { active, borderSeparator, className, disabled, children, selected, spacing, l10n, ...attr } = props;
    const spacingType = spacing && EGDSActionListItemSpacings.get(spacing);
    const ariaDesc = selected ? l10n.formatText('selected') : '';
    const baseCssClass = 'uitk-action-list-item';
    const cssClassNames = getClassNameList$1(baseCssClass, className, {
        [`${baseCssClass}-selected`]: selected,
        [`${baseCssClass}-active`]: active,
        [`${baseCssClass}-disabled`]: disabled,
        [`${baseCssClass}-${spacingType}`]: spacingType,
        [`${baseCssClass}-border`]: borderSeparator,
    });
    return (jsx(EGDSContextProvider, { config: {
            context: null,
            data: {
                contextAriaDesc: ariaDesc,
            },
        }, children: jsxs("li", { className: cssClassNames, ...attr, children: [jsx("div", { className: getClassNameList$1('uitk-action-list-item-content'), children: children }), selected && jsx(EGDSIcon, { className: getClassNameList$1('uitk-action-list-item-check'), name: "check" })] }) }));
};
const EGDSActionListItem = (props) => {
    const l10n = useLocalization();
    return jsx(ActionListItem, { l10n: l10n, ...props });
};
EGDSActionListItem.defaultProps = {
    spacing: 'standard',
};
EGDSActionListItem.displayName = 'EGDSActionListItem';

const getClassNameList = classNames.bind(styles);
// Defines the span that provides the aria description
const setAriaDescription = (desc, id) => desc ? (jsx("span", { className: "is-visually-hidden", id: id, children: desc })) : (jsx(Fragment, {}));
const EGDSActionListItemLink = (props) => {
    const { children, visuallyHideLinkText } = props;
    const { data: contextData } = useEGDSContext();
    const { contextAriaDesc } = contextData ?? {};
    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray[0];
    const randomId = Math.random().toString(36).substring(7);
    const uniqueSpanId = `selector-description-${randomId}`;
    if (!childrenArray || childrenArray.length !== 1) {
        console.warn(`UitkActionListItemLink uses the first child element. ${childrenArray.length} children found.`);
        return null;
    }
    const decoratedFirstChild = React.cloneElement(firstChild, {
        className: getClassNameList(firstChild.props.className, 'uitk-action-list-item-link', !visuallyHideLinkText && `uitk-action-list-item-link-has-visible-text`),
        'aria-describedby': contextAriaDesc ? uniqueSpanId : '',
    }, visuallyHideLinkText ? (jsxs("span", { className: "is-visually-hidden", children: [setAriaDescription(contextAriaDesc, uniqueSpanId), firstChild.props.children] })) : (jsxs(Fragment, { children: [setAriaDescription(contextAriaDesc, uniqueSpanId), firstChild.props.children] })));
    return decoratedFirstChild;
};
EGDSActionListItemLink.defaultProps = {
    visuallyHideLinkText: true,
};
EGDSActionListItemLink.displayName = 'EGDSActionListItemLink';

export { ActionListItem as A, EGDSActionList as E, EGDSActionListItem as a, EGDSActionListItemLink as b };
//# sourceMappingURL=index-chunk.esm.js.map
